import { render, staticRenderFns } from "./SearchPatient.vue?vue&type=template&id=5b06862b&scoped=true&"
import script from "./SearchPatient.vue?vue&type=script&lang=js&"
export * from "./SearchPatient.vue?vue&type=script&lang=js&"
import style0 from "./SearchPatient.vue?vue&type=style&index=0&id=5b06862b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06862b",
  null
  
)

export default component.exports